export const forumUrl = 'https://asktug.com';
export const blogUrl = 'https://tidb.net/blog';
